import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import HalamanDepan from "./pages/HalamanDepan";
import Auth from "./pages/Auth/Auth";
import AuthOTM from "./pages/Auth/AuthOTM";
import  DashboardS  from "./pages/siswaDashboard";
import  DashboardO  from "./pages/DashboardOTM";
import  FormAngket  from "./pages/FormAngket";
import  FormAngketOTM  from "./pages/FormAngketOTM";

function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to); 
  }, [to]);

  return null; 
}

function App() {
  return (
    <Routes>
      {/* root "/" -> domain eksternal */}
      {/* <Route
        path="/"
        element={<ExternalRedirect to="https://alazharsummarecon.sch.id/" />}
      /> */}

      <Route path="/" element={<HalamanDepan />} />
      <Route path="/student" element={<Auth />} />
      <Route path="/parent" element={<AuthOTM />} />

      <Route path="/dashboard-siswa" element={<DashboardS />} />
      <Route path="/assessment-form" element={<FormAngket />} />
      <Route path="/assessment-parent-form" element={<FormAngketOTM />} />

      <Route path="/dashboard-parent" element={<DashboardO />} />

      {/* fallback url lain */}
      {/* <Route
        path="*"
        element={<ExternalRedirect to="https://alazharsummarecon.sch.id/" />}
      /> */}
    </Routes>
  );
}

export default App;
